import styled from 'styled-components/macro';
 
export const ItemOverlay = styled.div`
  position: absolute;
  height: 40px;
  width: 93%;
  top: 0;
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: flex-end;
  gap: 8px;
  padding: 8px 12px;
`;
